



import React, { useEffect, useState } from "react";
import HomeCarousel from "../customer/Components/Carousel/HomeCarousel";
import { homeCarouselData } from "../customer/Components/Carousel/HomeCaroselData";
import HomeProductSection from "../customer/Components/Home/HomeProductSection";
import api from "../config/api"
import { Link } from "react-router-dom";
import { ProductList, TopcategoryHomeCarousel } from "../customer/Components/Home/TopSoldproductbycategory";


const Homepage = () => {

  const [Dresses, setDresses] = useState([])
  const [gouns, setgouns] = useState([])
  const [mensKurtas, setmensKurtas] = useState([])
  const [sarees, setsarees] = useState([])
  const [mensshoes, setmensshoes] = useState([])
  const [Topsolds, setTopsolds] = useState([])
  const [Top10productselledbycategory, setTop10productselledbycategory] = useState([])

  const loadProduct = async () => {
    try {
      const response = await api.get("/api/dashboard/getallproductshome");
      // console.log("all products", response)
      setDresses(response.data.dresses)
      setgouns(response.data.gouns)
      setmensKurtas(response.data.mensKurtas)
      setsarees(response.data.sarees)
      setmensshoes(response.data.shoes)

      const Topsold = await api.get("/api/totalsales/Top10ProductselledbyOrder?filter=month");
      setTopsolds(Topsold.data.top10Products)
      // console.log("all Topsold", Topsold.data.top10Products)


      const Top10productselledbycategory = await api.get("/api/totalsales/Top10productselledbycategory?filter=month");
      // console.log("Top10productselledbycategory - ", Top10productselledbycategory.data.topProductsByCategory)
      setTop10productselledbycategory(Top10productselledbycategory.data.topProductsByCategory)

    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    loadProduct()
  }, [])

  // console.log("sorting", gouns, Dresses, sarees, mensshoes, mensKurtas)

  return (
    <div className="">
      <HomeCarousel images={homeCarouselData} />

      <div className="space-y-10 py-20 ">
        {/* <Link to="" ><HomeProductSection data={mensKurtas} section={"Men's Kurta"} /></Link> */}
        <HomeProductSection data={Topsolds} section={"Top Solds"} />

        <TopcategoryHomeCarousel data={Top10productselledbycategory}/>
       
      </div>


    </div>
  );
};

export default Homepage;